/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export function tabNameToIndex(tabName) {
    switch (tabName) {
        case 'tours':
            return 0;
        case 'booking':
            return 1;
        case 'fees':
            return 2;
        case 'info':
            return 3;
        case 'ratings':
            return 4;
        default:
            return 0;
    }
}

export function tabIndexToName(index) {
    switch (index) {
        case 0:
            return 'tours';
        case 1:
            return 'booking';
        case 2:
            return 'fees';
        case 3:
            return 'info';
        case 4:
            return 'ratings';
        default:
            return 'tours';
    }
}
